import React, { useEffect, useRef, useState } from 'react'

import getYears, { GetYearsOptions, Year } from 'api/vehicles/getYears'
import { FormikDropdown } from 'components/FormikFields'
import { FormikDropdownChild } from 'components/FormikFields/FormikDropdown/FormikDropdown'

interface QueryProps {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    formik: any
    dataSource?: string[]
    primaryVehicleId?: number
    assetType?: unknown
    prefilled?: boolean
}

const defaultProps = {
    dataSource: null,
    primaryVehicleId: null,
    assetType: null,
    prefilled: false,
}

export default function YearDropdown({
    formik,
    dataSource,
    primaryVehicleId,
    assetType,
    prefilled,
}: Readonly<QueryProps>) {
    const [response, updateResponse] = useState([] as Year[])
    const hasLoadedRef = useRef(false)
    const { vehicle } = formik.values
    const { condition } = vehicle
    const { year } = vehicle

    function getYearsForVehicle(abortController: AbortController) {
        const getYearsOptions = {
            condition,
            dataSource,
            assetType,
            primaryVehicleId,
        } as GetYearsOptions

        getYears(getYearsOptions, abortController)
            .then((years: Year[]) => {
                updateResponse(years)

                if (
                    hasLoadedRef.current &&
                    years.filter((e) => `${e.id}` === year).length === 0
                ) {
                    formik.setFieldValue('vehicle.year', '')
                }

                hasLoadedRef.current = true
            })
            .catch(() => {})
    }

    useEffect(() => {
        const abortController = new AbortController()

        if (condition) {
            getYearsForVehicle(abortController)
        }

        return () => abortController.abort()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [condition])

    if (response.length < 1) {
        return (
            <FormikDropdown
                name="vehicle.year"
                label="Year"
                placeholder="Select One"
                disabled
                prefilled={prefilled}
            >
                {{ name: '', value: '' }}
                {{ name: '', value: '' }}
            </FormikDropdown>
        )
    }

    return (
        <FormikDropdown
            name="vehicle.year"
            label="Year"
            placeholder="Select One"
            disabled={response.length === 0}
            error={year === null || year === ''}
            prefilled={prefilled}
        >
            {response.map((child: Year) => {
                const newBorn: FormikDropdownChild = {
                    name: child.id.toString(),
                    value: child.id.toString(),
                }

                return newBorn
            })}
        </FormikDropdown>
    )
}

YearDropdown.defaultProps = defaultProps
